import { CalendarIcon, ChevronDownIcon } from '@icon/index';
import { DatePicker } from '@library/datepicker';
import useLiveLapseLogsListData from 'modules/analytics/hooks/useLiveLapseLogsListData';
import LiveLapseLogsList from 'modules/analytics/components/LiveLapseLogsList/LiveLapseLogsList';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import moment from 'moment';
import { useMemo, useState } from 'react';
import SelectDropdown from '@components/SelectDropDown/SelectDropDown';
import { useSearchParams } from 'react-router-dom';
import { ProcessStatusEnum, ProcessStatusLabels } from '@api/enum';
import MultiImageLogsList from 'modules/analytics/components/MultiImageLogsList/MultiImageLogsList';
import useMultiImageLogsListData from 'modules/analytics/hooks/useMultiImageLogsListData';
import ProgressLineActivityList from 'modules/analytics/components/ProgressLineActivityList/ProgressLineActivityList';
import useProgressLineActivityListData from 'modules/analytics/hooks/useProgressLiveActivityListData';
import { Label } from '@hyperflake/react-ui-library';

const ProgressLineActivityPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialFilter = searchParams.get('filter') || 'ALL';

    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));

    const formattedStart = startDate.format('YYYY-MM-DD');
    const formattedEnd = endDate.format('YYYY-MM-DD');

    const {
        data: activityData,
        isLoading,
        search,
        changeSearch,
    } = useProgressLineActivityListData(formattedStart, formattedEnd);

    // const filterOptions = useMemo(() => {
    //     return [
    //         {
    //             label: `All Logs (${statusCounts.ALL})`,
    //             value: 'ALL',
    //         },
    //         ...Object.values(ProcessStatusEnum).map((status) => ({
    //             label: `${ProcessStatusLabels[status]} (${statusCounts[status] || 0})`,
    //             value: status,
    //         })),
    //     ];
    // }, [statusCounts]);

    return (
        <PageTemplate>
            <PageHeading className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="">ProgressLine Activity</div>

                <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-end sm:gap-4">
                    {/* From Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">From Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 
          placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={startDate.toDate()}
                                maxDate={endDate.toDate()}
                                onChange={(date) => {
                                    const newStart = moment(date).startOf('day');
                                    setStartDate(newStart);
                                    if (newStart.isAfter(endDate)) setEndDate(newStart.endOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>

                    {/* To Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">To Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 
          placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={endDate.toDate()}
                                minDate={startDate.toDate()}
                                onChange={(date) => {
                                    const newEnd = moment(date).endOf('day');
                                    setEndDate(newEnd);
                                    if (newEnd.isBefore(startDate)) setStartDate(newEnd.startOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>
                </div>
            </PageHeading>

            <div>
                <ProgressLineActivityList isLoading={isLoading} activityData={activityData} />
            </div>
        </PageTemplate>
    );
};

export default ProgressLineActivityPage;
